import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { auth } from "../config/firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";

// ==================== DEV MODE ====================
export const DEV_MODE = false;
// ==================================================

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        if (DEV_MODE) {
            setIsAuthenticated(true);
            const devRole = allowedRoles.length > 0 ? allowedRoles[0] : "ADMIN";
            setUserRole(devRole);
            setLoading(false);
            return;
        }
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                const token = await user.getIdTokenResult();
                const role = token.claims.role || localStorage.getItem("userRole") || "USER";
                
                const authToken = await user.getIdToken();
                localStorage.setItem("authToken", authToken);
                localStorage.setItem("userRole", role);
                
                setIsAuthenticated(true);
                setUserRole(role);
            } else {
                localStorage.removeItem("authToken");
                localStorage.removeItem("userRole");
                setIsAuthenticated(false);
                setUserRole(null);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, [allowedRoles]);

    if (loading) {
        return null;
    }

    if (!isAuthenticated) {
        return <Navigate to="/auth" replace />;
    }

    if (allowedRoles.length > 0) {
        const normalizedRole = userRole?.toUpperCase();
        const normalizedAllowedRoles = allowedRoles.map(r => r.toUpperCase());
        
        if (!normalizedAllowedRoles.includes(normalizedRole)) {
            return <Navigate to="/auth" replace />;
        }
    }

    return children;
};

export default ProtectedRoute;